<div class="lpx-menu-item-link d-flex align-items-center justify-content-between" style="cursor:default;">
  <span class="lpx-menu-item-icon"><i class="lpx-icon fas fa-clock"></i></span>
  <span class="lpx-menu-item-text">24h Clock</span>
  <label class="nexweb-clock-toggle" (click)="$event.stopPropagation()">
    <input type="checkbox" [checked]="is24h()" (change)="onToggle($event)" />
    <span class="nexweb-clock-slider"></span>
  </label>
</div>
